// General
import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Styles
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './WriteReview.css';

// Component
import ReviewRating from '../../components/Reviews/Rating';

// Graphql
import WriteReviewDataQuery from './WriteReviewData.graphql';
import { withQuery } from '../../hoc/withGraphql';

class WriteReview extends React.Component {
  static propTypes = {
    reservationId: PropTypes.number.isRequired,
    writeReview: PropTypes.shape({
      loading: PropTypes.bool,
      writeReviewData: PropTypes.object
    }),
  };

  static defaultProps = {};

  render() {
    const { writeReview } = this.props;
    return (
      <div className={s.root}>
          <ReviewRating data={writeReview} />
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  withQuery(WriteReviewDataQuery,
    {
      name: 'writeReview',
      options: (props) => ({
        variables: {
          reservationId: props.reservationId,
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(WriteReview);
